import React from 'react';
import { BaseRestrictionsEnableControl } from 'src/components/enterprise/features/Corporate/components/Form/common/BaseRestrictionsEnable/BaseRestrictionsEnableControl';

export interface ItemRestrictionsEnableProps {
  name: string;
  id: string;
}

export function ItemRestrictionsEnableControl({
  name,
  id,
}: ItemRestrictionsEnableProps): JSX.Element {
  return (
    <BaseRestrictionsEnableControl id={id} name={name} label="Restrict items" />
  );
}
